import { Params, Router } from "@angular/router";
import { PolizaStoreService } from "../../services/store/poliza-store.service";
import { CatalogoSvgStoreService } from "../../services/store/catalogo-svg-store.service";

export abstract class FlujoPolizaNavigationComponent <T extends PolizaStoreService = PolizaStoreService>{
  protected readonly desdeFlujo: boolean;
  protected readonly rutaOrigen: string;
  protected readonly navParams: Params;

  constructor(
    protected router: Router,
    protected polizaStore: T,
    protected catalogoSvgStore: CatalogoSvgStoreService
  ) {
    const nav = this.router.getCurrentNavigation();
    this.navParams = nav?.extras?.queryParams || {};
    const state = (nav?.extras?.state as { desdeFlujo?: boolean; rutaOrigen?: string }) || {};
    this.desdeFlujo = !!state.desdeFlujo;
    const rawUrl = state.rutaOrigen ?? this.router.url;
    this.rutaOrigen = rawUrl.split('?')[0];
    
    if (!this.desdeFlujo) {
      this.polizaStore.limpiarStore();
      this.catalogoSvgStore.limpiarCatalogoProtocolo();
    }
  }

  protected volver(params?: Params) {
    this.router.navigate(
      [this.rutaOrigen],
      {
        queryParams: params || this.navParams,
        state: {
          desdeFlujo: true,
          rutaOrigen: this.rutaOrigen
        }
      }
    );
  }

  protected navigate(
    ruta: string,
    desdeFlujo: boolean,
    params?: Params,
    extraState: Record<string, any> = {}
  ) {
    this.router.navigate([ruta], {
      queryParams: params,
      state: {
        desdeFlujo,
        rutaOrigen: this.router.url,
        ...extraState
      }
    });
  }

  protected getNavigationParam<T = any>(clave: string): T | undefined {
    return this.navParams?.[clave] as T;
  }
}
